import React, { useEffect } from 'react'
import { BootstrapController } from '../controller/bootstrap-controller'
const BootstrapControllerUI = () => {
  useEffect(() => {
    BootstrapController()
  }, [])
  return <></>
}

export default BootstrapControllerUI
